import React from 'react';

import Home from '../../containers/Home'
const HomeView = () => {
    return(

         
            <Home/>
   
        )}

export default HomeView;